@keyframes common-fade-in {
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.common-fade-in {
  opacity: 0;
  transform: translateX(-10px);
  animation-duration: 125ms;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  animation-name: common-fade-in;
  animation-timing-function: ease-out;
}
